import styled from 'styled-components';

export const Divider = styled.div`
    height: 1px;
    width: 100%;
    background: rgba(0, 0, 0, 0.05);
    margin: 1rem 0;
`;
